/** Buyer with status customer and customer_status active (repeat / established customer). */
export function isActiveStoreCustomer(currentUser) {
  if (!currentUser) return false;
  const buyer = currentUser.buyer;
  if (!buyer) return false;

  return buyer.status === "customer" && buyer.customer_status === "active";
}
